import React from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'

const Alert = ({ showAlert, data }) => {
  if (!showAlert) {
    return <></>
  }

  return (
    <div class="overlay">
      <Modal className="modal-box" id="maintenance-modal" isOpen={true} toggle={() => {}}>
        <h2>{data?.title || "We'll Be Right Back!"}</h2>
        <ModalBody>
          {data?.message || (
            <p>
              We are currently performing some routine maintenance to keep things running smoothly.{' '}
              <br />
              <br />
              Thanks for bearing with us.
            </p>
          )}
        </ModalBody>
      </Modal>
    </div>
  )
}

export default Alert
